export default __webpack_public_path__ + "static/media/yekg-logo.5f2fc192.svg";